interface ErrorDetails {
  error: string
}

const extractErrorCause = (cause: any) => {
  const errorKeys = Object.keys(cause)

  const mappedErrors = errorKeys.map((errorKey) => {
    const error: ErrorDetails[] = cause[errorKey]
    const errorCodes = error.map((err) => `${err.error}`)

    return `${errorKey} ${errorCodes.join()}`
  })

  return mappedErrors
}

// Very unfortunate, but we really don't know the type of the error
const extractErrorsForTracking = (errorData?: any) => {
  const errorCause = errorData?.cause?.error_details
  const baseErrors = errorData?.baseErrors as string[]

  if (errorCause) {
    return extractErrorCause(errorCause)
  }

  if (baseErrors) {
    return baseErrors
  }

  return undefined
}

export default extractErrorsForTracking
